export default function LogoIcon({ className }: { className?: string }) {
  return (
    <svg width="450" height="300" viewBox="0 0 450 300" className={className}>
      <g className="layer">
        <g
          id="logo-logo"
          transform="matrix(1 0 0 1 0 0) translate(0 -53) matrix(1.52355 0 0 1.52355 227.603 201.899)"
        >
          <g id="svg_2">
            <g
              id="svg_3"
              transform="matrix(0.07953959105198867 0 0 -0.07953959105198867 72.85214879484442 -59.168979054200236)"
            >
              <path
                d="m4379.64,4149.26c124.85,0 226.08,101.19 226.08,226.09c0,124.89 -101.23,226.11 -226.08,226.11c-124.85,0 -226.1,-101.22 -226.1,-226.11c0,-124.9 101.25,-226.09 226.1,-226.09"
                fill="currentFill"
                fillRule="nonzero"
                id="svg_4"
                strokeDashoffset="0"
                strokeMiterlimit="4"
                transform=" translate(-4379.63, -4375.360000000001)"
              />
            </g>
            <g
              id="svg_5"
              transform="matrix(0.07953959105198867 0 0 -0.07953959105198867 0 33.727147186844746)"
            >
              <path
                d="m4843.36,3232.64l-193.62,-190.06l-36.96,-36.32c-109.25,-107.2 -287.03,-107.25 -396.24,0l-754.57,740.73l-754.55,-740.73c-109.25,-107.2 -287.01,-107.25 -396.28,0l-37.38,36.72l-193.62,190.05l-192.73,-191.01l193.63,-190.06l40.04,-39.3c214.05,-210.13 562.35,-210.13 776.38,0l564.51,554.13l564.48,-554.13c107.05,-105.1 247.61,-157.57 388.2,-157.57c140.52,0 281.19,52.5 388.18,157.57l39.56,38.85l193.65,190.03l-192.68,191.1"
                fill="currentFill"
                fillRule="nonzero"
                id="svg_6"
                strokeDashoffset="0"
                strokeMiterlimit="4"
                transform=" translate(-3461.7250000000004, -3201.02625)"
              />
            </g>
            <g
              id="svg_7"
              transform="matrix(0.07953959105198867 0 0 -0.07953959105198867 0 -19.851946371268326)"
            >
              <path
                d="m3263.9,4024.13c109.21,107.23 286.98,107.23 396.2,0l659.55,-647.4l190.03,193.58l-659.51,647.38c-214.04,210.21 -562.31,210.18 -776.35,0.05l-659.53,-647.43l190.03,-193.58l659.58,647.4"
                fill="currentFill"
                fillRule="nonzero"
                id="svg_8"
                strokeDashoffset="0"
                strokeMiterlimit="4"
                transform=" translate(-3461.984999999999, -3876.036250044607)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
